import { CollateralComponent } from "projects/reg-hub-client/src/app/orders/collateral/collateral.component";
import { DebtorsComponent } from "projects/reg-hub-client/src/app/orders/debtors/debtors.component";
import { SKLienDetailsComponent } from "projects/reg-hub-client/src/app/orders/lien-details/sk-lien-details/sk-lien-details.component";
import { RegisteringAgentComponent } from "projects/reg-hub-client/src/app/orders/registering-agent/registering-agent.component";
import { ReviewComponent } from "projects/reg-hub-client/src/app/orders/review/review.component";
import { SecuredPartiesComponent } from "projects/reg-hub-client/src/app/orders/secured-parties/secured-parties.component";
import { Step, StepValidationState } from "projects/reg-hub-client/src/interfaces/step";
import { Stepper } from "projects/reg-hub-client/src/interfaces/stepper";
import { ConfigurationState } from "reg-hub-common";

export class SKRepairLienStepper implements Stepper {
    
    steps: Step[];

    constructor(configurationState: ConfigurationState) {
        this.steps = [
            { title: "Details", content: SKLienDetailsComponent, validationState: StepValidationState.DefaultState },
            { title: "Debtors", content: DebtorsComponent, validationState: StepValidationState.DefaultState },
            { title: "Sec. Parties", content: SecuredPartiesComponent, validationState: StepValidationState.DefaultState },
            ...(
                configurationState.shouldShowRegisteringAgentTab()
                    ? [{ title: "Agent", content: RegisteringAgentComponent, validationState: StepValidationState.DefaultState }]
                    : []
            ),
            { title: "Collateral", content: CollateralComponent, validationState: StepValidationState.DefaultState },
            { title: "Review", content: ReviewComponent, validationState: StepValidationState.DefaultState }
        ]
    }
}